import $http from '@vue-util/http';

const productXapiFetchSmall = async (productId, urlParams = {}, emitMetaData) => {
  urlParams.size = 'small';
  const searchParams = new URLSearchParams(urlParams).toString();
  const url = `/xapi/digital/v1/product/${productId}?${searchParams}`;

  try {
    const response = await $http.get(url);
    let product;
    if (response.data.product[0]) {
      product = response.data.product[0];
      if (emitMetaData) {
        product.meta = response.data.meta;
      }
      return product;
    }
    return {};
  } catch (e) {
    return null;
  }
};

export default productXapiFetchSmall;
